<template>
  <div v-if="isMaxScreen" class="pc_choose-device">
    <Head></Head>
    <div style="flex: 1; overflow-y: auto; height: 100%">
      <PC-order-step></PC-order-step>
      <PC-bread-nav :not-invite="notInvite" :show-back="!notInvite"></PC-bread-nav>
      <div class="device-main">
        <div class="device-item">
          <PC-device-info
            :not-invite="notInvite"
            :modelUrl="modelUrl"
            :phoneModel="phoneModel"
          ></PC-device-info>
          <PC-model-info
            ref="propertyList"
            :properties="properties"
            :brandId="brandId"
            :multiSelectId="multiSelectId"
            :canNotOpenOptions="canNotOpenOptions"
            :total="total"
            :current="current"
            :disabled="!canClick"
            @selectAnswer="selectAnswer"
            @multiSelectAnswer="multiSelectAnswer"
            @showAnswers="showAnswers"
            @submit="submit"
            @changeCurrent="changeCurrent"
            @changeQrcode="changeQrcode"
          ></PC-model-info>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="wrapper">
    <h-head></h-head>
    <!-- 加载中 -->
    <!-- <my-loading v-if="loading"></my-loading> -->
    <!-- 头部进度条和机型 -->
    <properties-header :title="phoneModel" :current="current" :total="total"></properties-header>
    <!--机型属性列表-->
    <property-list
      ref="propertyList"
      :data="properties"
      :brandId="brandId"
      :total="total"
      :current="current"
      :multiSelectId="multiSelectId"
      :canNotOpenOptions="canNotOpenOptions"
      @selectAnswer="selectAnswer"
      @multiSelectAnswer="multiSelectAnswer"
      @showAnswers="showAnswers"
      @changeCurrent="changeCurrent"
      @changeQrcode="changeQrcode"
    ></property-list>
    <!-- 底部按钮 -->
    <properties-footer
      :loading="btnLoading"
      :canClick="canClick"
      @submit="submit"
    ></properties-footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import hHead from '@/components/layout/head.vue';
import PCBreadNav from '@/components/PCBreadNav';
import PCOrderStep from '@/components/PCOrderStep';
import { lang } from '@/locales';
import { getChannelId, getNationCode } from '@/utils/channel';

import Head from '../../components/head';
// import backLastPage from '@/mixins/backLastPage.js';
// import { isTestOrder, getBrandName, filterStoreType, getUserInfo } from '@/libs/util'
import { evaluation, phoneModelProperties } from '../../services/api/property';
import PCDeviceInfo from './components/PCDeviceInfo';
// import PCHeadNav from '../components/PCHeadNav'
// import PCBreadNav from '../components/PCBreadNav'
import PCModelInfo from './components/PCModelInfo';
import PropertiesFooter from './components/properties-footer.vue';
// import commonHeader from '_c/commonHeader.vue'
// import MyLoading from "@/components/my-loading";
import PropertiesHeader from './components/properties-header.vue';
import PropertyList from './components/property-list.vue';
import {
  getAnswerIdMapByLang,
  getQuestionnaireByLang,
  getSkuQuestionnaireByLang
} from './components/questionnaireData.js';

export default {
  name: 'Property',
  components: {
    // "my-loading": MyLoading,
    PropertiesHeader,
    PropertiesFooter,
    PropertyList,
    hHead,
    Head,
    // PCHeadNav,
    // PCBreadNav,
    PCModelInfo,
    PCDeviceInfo,
    PCBreadNav,
    PCOrderStep
    // commonHeader
  },
  // mixins: [backLastPage],
  data() {
    return {
      multiSelectId: null,
      brandId: null,
      loading: false,
      phoneModel: '',
      btnLoading: false,
      phoneId: null,
      // skuList: [],
      properties: [],
      standardTemplateId: '', // 保价相关
      canNotOpenOptions: JSON.parse(sessionStorage.getItem('canNotOpenOptions'))
        ? JSON.parse(sessionStorage.getItem('canNotOpenOptions'))
        : [],
      userInfo: null,
      fold: null,
      isComplete: false,
      imei: '',

      propertyList: null,

      modelUrl: '',

      notInvite: true,

      userInfo: {},

      qrCode: '',
      skuQuestionnaireData: getSkuQuestionnaireByLang(lang),
      questionnaireData: getQuestionnaireByLang(lang)
    };
  },
  computed: {
    // 判断是否是PC端
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    }),
    /**
     * 提交按钮是否可点击
     */
    canClick() {
      if (this.isComplete) {
        return true;
      }
      // let properties = JSON.parse(JSON.stringify(this.properties));
      // //不考虑多选项（多选项总是最后一项）
      // if (this.multiSelectId) {
      //   properties.pop();
      // }
      // //首次进来，selected还没生成，需要捕获一下异常。注意：功能性问题不用判断
      // try {
      //   let allSelected = properties.every((item, index) => {
      //     return item.selected !== "";
      //   });
      //   return !this.loading && allSelected;
      // } catch (err) {
      //   return false;
      // }
    },
    /**
     * 总进度
     */
    total() {
      const properties = JSON.parse(JSON.stringify(this.properties));
      //不考虑多选项（多选项总是最后一项）
      if (this.multiSelectId) {
        properties.pop();
      }
      return properties.length + 1;
    },
    /**
     * 当前进度
     */
    current() {
      const properties = JSON.parse(JSON.stringify(this.properties));
      if (this.isComplete) {
        return properties.length + 1;
      }
      //不考虑多选项（多选项总是最后一项）
      if (this.multiSelectId) {
        properties.pop();
      }
      const arr = properties.filter(item => item.selected !== '');
      return arr.length;
    }
  },
  created() {
    this.init();
  },
  beforeRouteEnter(to, from, next) {
    //如果从选择机型页、搜索页面进入当前页，清除已选设备属性
    if (from.name === 'Product' || from.name === 'Search') {
      localStorage.removeItem('choosed_device_properties');
    }
    next();
  },
  methods: {
    /**
     * 初始化
     */
    async init() {
      // this.userInfo = getUserInfo() // 获取用户埋点
      this.phoneId = this.$route.query.id;
      let choosed_device_properties = localStorage.getItem('choosed_device_properties');
      if (choosed_device_properties) {
        choosed_device_properties = JSON.parse(choosed_device_properties);
        this.phoneModel = choosed_device_properties.phoneModel;
        this.properties = choosed_device_properties.properties;
        this.multiSelectId = choosed_device_properties.multiSelectId;
        // this.skuList = choosed_device_properties.skuList;
        this.brandId = choosed_device_properties.brandId;
        this.standardTemplateId = choosed_device_properties.standardTemplateId;
      } else {
        const specHintArr = await this.productSpecHint(this.phoneId).catch(err => {});
        this.getProperties(this.phoneId, specHintArr);
      }

      // 根据当前语言替换问卷问题
      // this.replaceQuestionsByLang();
      console.log('this.properties', this.properties);
    },

    // /**
    //  * 根据语言替换问题文本
    //  */
    // replaceSkuQuestionsByLang(data) {

    //   const questionnaireData = getSkuQuestionnaireByLang(lang);

    //   questionnaireData.forEach(questionItem => {
    //     const questionId = questionItem['Question ID'];
    //     const questionText = questionItem['Question'];

    //     // 查找 this.properties 中 id 匹配的项
    //     const matchedProperty = data.find(prop => prop.id === questionId);

    //     if (matchedProperty) {
    //       // 替换 question 字段
    //       matchedProperty.basicSpecName = questionText;
    //     }
    //   });

    //   return data;
    // },

    // /**
    //  * 根据语言替换问题文本
    //  */
    // replaceQuestionsByLang(data) {
    //   const questionnaireData = getQuestionnaireByLang(lang);

    //   questionnaireData.forEach(questionItem => {
    //     const questionId = questionItem['Question ID'];
    //     const questionText = questionItem['Question'];

    //     console.log(this.properties, 'this.properties');

    //     // 查找 this.properties 中 id 匹配的项
    //     const matchedProperty = data.find(prop => prop.id === questionId);

    //     if (matchedProperty) {
    //       // 替换 question 字段
    //       matchedProperty.standardSpecName = questionText;
    //     }
    //   });

    //   const answerIdList = [
    //     { key: 55, value: 'Sí' },
    //     { key: 56, value: 'No' },
    //     { key: 58, value: 'Sí' },
    //     { key: 59, value: 'No' },
    //     { key: 60, value: 'Sí' },
    //     { key: 61, value: 'No' },
    //     { key: 62, value: 'Sí' },
    //     { key: 63, value: 'No' },
    //     { key: 64, value: 'Sí' },
    //     { key: 65, value: 'No' },
    //     { key: 66, value: 'Sí' },
    //     { key: 67, value: 'No' },
    //     { key: 68, value: 'Sí' },
    //     { key: 69, value: 'No' }
    //   ];

    //   data.forEach(matchedProperty => {
    //     matchedProperty.optionList.forEach(item => {
    //       answerIdList.forEach(answer => {
    //         if (item.id === answer.key) {
    //           item.optionName = answer.value;
    //         }
    //       });
    //     });
    //   });

    //   return data;
    // },

    /**
     * 根据语言替换问卷数据（问题和答案）
     * @param {Array} data - 需要替换的数据
     * @param {Object} options - 配置选项
     * @param {boolean} options.isSku - 是否为 SKU 问卷，默认 false
     * @param {boolean} options.replaceAnswers - 是否替换答案文本，默认 false
     */
    replaceByLang(data, options = { isSku: false, replaceAnswers: false }) {
      const { isSku, replaceAnswers } = options;

      // 1. 替换问题文本
      const questionnaireData = isSku
        ? getSkuQuestionnaireByLang(lang)
        : getQuestionnaireByLang(lang);

      const questionMap = new Map(
        questionnaireData.map(item => [item['Question ID'], item['Question']])
      );

      const fieldName = isSku ? 'basicSpecName' : 'standardSpecName';

      data.forEach(prop => {
        const questionText = questionMap.get(prop.id);
        if (questionText) {
          prop[fieldName] = questionText;
        }
      });

      // 2. 替换答案文本（如果需要）
      if (replaceAnswers) {
        const answerMap = getAnswerIdMapByLang(lang);

        data.forEach(prop => {
          if (prop.optionList && Array.isArray(prop.optionList)) {
            prop.optionList.forEach(item => {
              const answerText = answerMap.get(item.id);
              if (answerText) {
                item.optionName = answerText;
              }
            });
          }
        });
      }

      return data;
    },
    /**
     * 显示问号弹窗
     */
    showQuestionPopup() {
      this.$refs.question.show();
    },
    /**
     * 格式化itemList
     */
    formatItemList(itemList) {
      itemList.forEach((item, index) => {
        //处理答案项
        this.properties.push({
          id: item.id,
          question: item.basicSpecName,
          selected: '',
          showAnswers: false,
          // answers: answers,
          optionList: item.optionList,
          keyName: 'itemList',
          specDesc: item?.specDesc,
          specImageList: item?.specImageList
        });
      });
    },
    /**
     * 格式化standardSpecificationList
     */
    formatStandardSpecificationList(standardSpecificationList, specHintArr = []) {
      standardSpecificationList.forEach(item => {
        //处理答案项
        // let answers = item.optionList.map((answer) => {
        //   return {
        //     id: answer.id,
        //     name: answer.optionName,
        //   };
        // });
        let specHint = '';
        Boolean(specHintArr) &&
          specHintArr.length > 0 &&
          specHintArr.forEach(o => {
            if (o.specId == item.id) {
              specHint = o.specHint;
            }
          });
        // let selected = item.id === 8 ? [] : "";
        const selected = item.id == this.multiSelectId ? [] : '';
        this.properties.push({
          id: item.id,
          question: item.standardSpecName,
          selected: selected,
          showAnswers: false,
          // answers: answers,
          optionList: item.optionList,
          specHint,
          keyName: 'standardSpecificationList',
          specDesc: item?.specDesc,
          specImageList: item?.specImageList
        });
      });
    },
    /**
     * 获取机型属性
     */
    getProperties(id, specHintArr = []) {
      this.loading = true;
      const channelId = getChannelId();
      const nation = getNationCode();

      phoneModelProperties({ productId: id, channelId: channelId, nation: nation })
        .then(res => {
          setTimeout(() => {
            this.loading = false;
          }, 300);
          if (res.code === '0000') {
            this.brandId = res.data.brandId;
            this.standardTemplateId = res.data.standardTemplateId;
            this.multiSelectId = res.data.multiSelectId;
            this.phoneModel = res.data.name;
            const itemList = this.replaceByLang(res.data.itemList, { isSku: true });
            // const standardSpecificationList = this.replaceQuestionsByLang(
            //   res.data.standardSpecificationList
            // );
            const standardSpecificationList = this.replaceByLang(res.data.standardSpecificationList, { isSku: false, replaceAnswers: true });
            console.log('itemList', itemList);
            console.log('standardSpecificationList', standardSpecificationList);
            this.formatItemList(itemList);
            this.formatStandardSpecificationList(standardSpecificationList, specHintArr);
            this.properties[0].showAnswers = true;
            this.canNotOpenOptions = res.data.canNotOpenOptions;
            sessionStorage.setItem('canNotOpenOptions', JSON.stringify(this.canNotOpenOptions));
            // this.fold = res.data.fold; // 是否为折叠机
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },

    /**
     * 获取机型属性
     */
    productSpecHint(id) {
      return new Promise((resolve, reject) => {
        this.$api
          .productSpecHint({
            productId: 1
          })
          .then(res => {
            if (res.code == '0000') {
              resolve(res.data || []);
            } else {
              reject();
            }
          })
          .catch(err => {
            reject();
          });
      });
    },
    /**
     * 选择属性后向上滚动
     */
    handleScroll(index) {
      const propertyItem = this.$refs.propertyList.$refs.item[0];
      const itemHeight = propertyItem.offsetHeight * index;
      window.scrollTo(0, itemHeight);
    },

    /**
     * 功能性问题选择答案（可多选或不选）
     * @param propertyIndex
     * @param name
     */
    multiSelectAnswer(propertyIndex, name) {
      //注意：selected在data中定义的是''，为了支持多选，此处将其转成[]
      const selectedList = this.properties[propertyIndex].selected
        ? this.properties[propertyIndex].selected
        : [];
      const currentIndex = selectedList.indexOf(name);
      if (currentIndex !== -1) {
        selectedList.splice(currentIndex, 1);
      } else {
        selectedList.push(name);
      }
      this.$set(this.properties[propertyIndex], 'selected', selectedList);
      this.saveSelectedProperties();
    },

    /**
     * 显示答案项列表
     * @param propertyIndex
     */
    showAnswers(propertyIndex) {
      //重置收缩所有的答案项
      this.properties.forEach(item => {
        item.showAnswers = false;
      });
      this.$set(this.properties[propertyIndex], 'showAnswers', true);
    },

    /**
     * 保存已选机型属性，避免刷新和切换页面时丢失
     */
    saveSelectedProperties() {
      localStorage.setItem(
        'choosed_device_properties',
        JSON.stringify({
          phoneModel: this.phoneModel,
          properties: this.properties,
          // skuList: this.skuList,
          brandId: this.brandId,
          multiSelectId: this.multiSelectId,
          standardTemplateId: this.standardTemplateId,
          fold: this.fold
        })
      );
    },
    /**
     * 选择答案
     * @param propertyIndex
     * @param answer
     */
    selectAnswer(propertyIndex, answer) {
      //当前机况属性还没选时才让其自动向上滚动，已选择（即修改）时不自动滚动
      if (!this.properties[propertyIndex].selected) {
        setTimeout(() => {
          this.handleScroll(propertyIndex);
        }, 100);
      }
      this.$set(this.properties[propertyIndex], 'selected', answer);
      this.$set(this.properties[propertyIndex], 'showAnswers', false);

      //自动显示下面未选择过的答案项列表（已选择过的不显示）
      for (let i = 0; i < this.properties.length; i++) {
        if (this.properties[i].selected === '' || this.properties[i].selected.length === 0) {
          this.$set(this.properties[i], 'showAnswers', true);
          break;
        }
      }
      this.saveSelectedProperties();
    },
    /**
     * 获取选中的机况id集合（有id的机况）
     */
    getOptionIds() {
      let optionIds = []; //已选项id集合，包含ids和lastOneIds
      const ids = []; //除功能项问题外，有id的已选项
      let lastOneIds = []; //功能性问题（最后一项）的已选id
      this.properties.forEach(item => {
        //判断id是否是数字（前面获取数据的时候为了方便渲染而格式化过，有些机况id不存在，设置成与name相同的字符串）
        // if (Number.isInteger(item.id)) { // 保价版本： 接口数据变更，itemList加了id，不能再这样判断
        if (item.keyName == 'standardSpecificationList' && item.optionList) {
          if (Array.isArray(item.selected)) {
            //功能性列表（最后一项）的selected是数组，单独获取它的id
            const filterAnswers = item.optionList.filter(answer => {
              if (item.selected.includes(answer.optionName)) {
                return answer.id;
              }
            });
            lastOneIds = filterAnswers.map(item => item.id);
          } else {
            const id = item.selected.id;
            id && ids.push(id);
          }
        }
      });
      optionIds = ids.concat(lastOneIds);
      return optionIds;
    },
    // 获取选中的itemList选项
    getItemIds() {
      let itemListOptions = [];
      itemListOptions = this.properties.filter(o => o.keyName == 'itemList');
      itemListOptions = itemListOptions.map(o => ({
        attributeName: o.id,
        attributeValue: o.selected ? o.selected.id : ''
      }));
      return JSON.stringify(itemListOptions);
    },
    /**
     * 是否无法开机
     */
    cannotOpenPhone() {
      //获取 “使用情况” 这一项
      const useCase = this.properties.filter(item => item.id === 3);
      return useCase[0].selected === '无法开机/无法进入桌面'; // 无法开机/无法进入桌面
    },
    /**
     * 提交
     */
    submit() {
      this.evaluation();
    },
    /**
     * 估价
     */
    evaluation() {
      const optionIds = this.getOptionIds();
      const itemIds = this.getItemIds();
      const channelId = getChannelId();
      const nation = getNationCode();

      const data = {
        productId: this.phoneId,
        itemIds,
        optionIds,
        channelId: channelId,
        imei: this.imei,
        nation: nation,
        standardTemplateId: this.standardTemplateId,
        qrCode: this.qrCode
      };
      this.btnLoading = true;
      evaluation(data)
        .then(res => {
          this.btnLoading = false;
          if (res.code === '0000') {
            res.data.productId = this.phoneId;
            res.data.brandId = this.brandId;
            res.data.optionIds = optionIds;
            this.$router.push({
              name: 'Evaluate',
              query: {
                data: JSON.stringify(res.data),
                id: this.$route.query.id
              }
            });
          } else {
            console.log(res);
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(err.message);
          this.btnLoading = false;
        });
    },
    changeCurrent(data) {
      console.log('imei', data);
      if (data?.length !== 15) {
        this.isComplete = false;
        this.imei = data;
      } else {
        this.isComplete = true;
        this.imei = data;
      }
    },
    changeQrcode(data) {
      console.log(data);
      this.qrCode = data;
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  font-size: 15px;
  color: #333;
  // padding: 65px 0 100px 0;
  padding: 88px 0 100px 0;
  overflow: auto;
  min-height: 100vh;
  background: #f5f5f5;
}

@media (min-width: 981px) {
  .pc_choose-device {
    background-color: #f8f8f8;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    width: 1200px;
    margin: 100px auto 0;
    .device-main {
      display: flex;
      justify-content: center;
      margin-bottom: 40px;
      .device-item {
        width: 1200px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>
